module.exports = __webpack_public_path__ + "img/orange_043.32006b0e.png";